module.exports = __webpack_public_path__ + "5e2b36b8726210ad184752334b7e4881.png";